// AI Generated Test
import { Component, OnInit } from '@angular/core';
import { DataPrivacyRulesetRepo } from '@client/app/modules/data-privacy/services/api/ruleset_repo';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { REGULATIONS } from '@client/app/modules/data-privacy/constants/regulations.constant';
import { INFOTYPE_GROUPS } from '@client/app/modules/data-privacy/constants/infotype-groups.constant';
import { default as REGIONS } from '@client/app/modules/data-privacy/constants/regions.constant.json';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { DataPrivacyService } from '@client/app/modules/data-privacy/services/data-privacy/data-privacy.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import {
    PrivacyViolationPagesComponent,
} from '@client/app/modules/data-privacy/dialogs/violation-pages/privacy-violation-pages.component';
import {
    PrivacyDialogsHelpCenterComponent,
} from '@client/app/modules/data-privacy/dialogs/help-center/help-center.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'privacy-checklist',
    standalone: false,
    template: `
        <div class="data-privacy" id="data-privacy-checklist">
            <page-header
                [icon]="['SIDEMENUES', 'DATA_PRIVACY', 'CHECKLIST'] | monIcons"
                [header]="'Checklist' | translate"
                [subHeader]="'List of checks with and without issues' | translate">
            </page-header>
            <mon-tabs
                    [options]="tabs"
                    [(status)]="activeTab"
                    (onStatus)="onStatus($event)"
                    (onSearch)="onSearch($event)"
                    [search]="search"
                    [minSearchLength]="1"
                    [showFiltersBtn]="showFilters"
                    [(isFiltersOpen)]="isFiltersOpen"
                    [showSearch]="true">
                <csv-export-button [exports]="exports"></csv-export-button>
            </mon-tabs>
            <div class="bg-white mt-1 panel-monsido-card">
                <div class="card-body">
                    <table-container
                        [noResultMessage]="'Good job! No violations were found' | translate"
                        [collection]="infoTypes"
                        (onPageChange)="onPageChange($event)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        [progress]="progress"
                        class="pages-table-wrapper">
                        <table-container-top>
                            <div class="outer-b merge-r-36 merge-l-36 merge-t-10" *ngIf="isFiltersOpen">
                                <table-filters
                                    [(open)]="isFiltersOpen"
                                    [(ngModel)]="filters"
                                    name="filters"
                                    [filters]="availableFilters"
                                    (onChanges)="onFiltersChanges($event)">
                                </table-filters>
                            </div>
                        </table-container-top>
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th monTableSort
                                    [monSortBy]="'group'"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)"
                                    [monThTitle]="'Type' | translate"
                                    class="text-left type-cell text-v-middle">
                                </th>
                                <th monTableSort
                                    [monSortBy]="'identifier'"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)"
                                    [monThTitle]="'Check name' | translate"
                                    class="text-left text-v-middle">
                                </th>
                                <th class="text-center text-v-middle">
                                    {{ 'Help center' | translate }}
                                </th>
                                <th class="text-center text-v-middle">{{ 'Country' | translate }}</th>
                                <th class="text-right text-v-middle">
                                    {{ 'Compliance' | translate }}
                                </th>
                                <th monTableSort
                                    [monSortBy]="'page_data_protection_violations_count'"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)"
                                    [monThTitle]="'Pages' | translate"
                                    class="text-right text-v-middle">
                                </th>
                                <th class="text-right text-v-middle">
                                    <span monTableSort
                                        [monSortBy]="'priority'"
                                        [monSortDirection]="currentSort.direction"
                                        [monCurrentlySortedBy]="currentSort.by"
                                        (monOnSorted)="onMonTableSort($event)"
                                        *ngIf="activeTab === 'passed'"
                                        [monThTitle]="'Severity' | translate">
                                    </span>
                                    <span *ngIf="activeTab !== 'passed'">
                                        {{ 'Severity' | translate }}
                                    </span>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let infoType of infoTypes">
                                <td class="text-left type-cell text-v-middle">
                                    <mon-data-privacy-info-type-icon
                                        [monGroup]="infoType.group"
                                        [monPriority]="infoType.priority"
                                        [monTooltipText]="formatText(infoType.group || 'other') | translate">
                                    </mon-data-privacy-info-type-icon>
                                </td>
                                <td class="text-left text-v-middle">
                                    {{ infoType.name }}
                                </td>
                                <td class="text-center help-center-icon text-v-middle">
                                    <span (click)="openHelpCenter(infoType)"
                                          role="button"
                                          [attr.aria-label]="'Go to help center' | translate"
                                          class="cursor-pointer text-link fas fa-graduation-cap help-center-icon"
                                          tabindex="0">
                                    </span>
                                </td>
                                <td class="text-center text-v-middle">
                                    <ul class="list-unstyled">
                                        <li *ngFor="let region of infoType.regions">
                                            <span class="text-capitalize">{{ formatText(region) }}</span>
                                        </li>
                                    </ul>
                                </td>
                                <td class="col-7 text-right text-v-middle">
                                    <table-css-compliance
                                            [errorCount]="getPagesWithActiveViolationCount(infoType)"
                                            [totalCount]="getTotalPageCount(infoType) || 1">
                                    </table-css-compliance>
                                </td>
                                <td class="text-right text-v-middle">
                                    <pages-button
                                        *ngIf="getPagesWithActiveViolationCount(infoType) > 0"
                                        (callback)="goToPages(infoType)"
                                        [ngModel]="infoType.info_type_domain_summary[0].pages_with_active_violations_count"
                                        name="pagesButton">
                                    </pages-button>
                                </td>
                                <td class="text-right text-v-middle">
                                    <mon-data-privacy-severity-level
                                        [monPriority]="infoType.priority"
                                        *ngIf="!loading">
                                    </mon-data-privacy-severity-level>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    `,
})
export class PrivacyChecklistComponent extends BaseContainerComponentController implements OnInit {
    infoTypes: any = [];
    tabs: any = [];
    override filters: any = { 'Data Regulations': [], 'Issue type': [], Country: [] };
    override availableFilters: any = {
        'Data Regulations': REGULATIONS,
        'Issue type': INFOTYPE_GROUPS,
        Country: REGIONS,
    };
    override showFilters: boolean = false;
    override isFiltersOpen: boolean = false;
    exports: any = [];
    loading: boolean = false;
    progress: any;

    constructor (
        private dataPrivacyRulesetRepo: DataPrivacyRulesetRepo,
        private translateService: TranslateService,
        private activeFeatureService: ActiveFeatureService,
        private dataPrivacyService: DataPrivacyService,
        private monEventService: MonEventService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.infoTypes = [];
        this.tabs = [
            {
                name: this.translateService.getString('High'),
                value: 'high',
            },
            {
                name: this.translateService.getString('Medium'),
                value: 'medium',
            },
            {
                name: this.translateService.getString('Low'),
                value: 'low',
            },
            {
                name: this.translateService.getString('Passed'),
                value: 'passed',
            },
        ];
        this.activeTab = this.tabs[0].value;
        this.currentSort = { by: 'identifier', direction: 'desc' };
        this.filters = { 'Data Regulations': [], 'Issue type': [], Country: [] };
        this.availableFilters = {
            'Data Regulations': REGULATIONS,
            'Issue type': INFOTYPE_GROUPS,
            Country: REGIONS,
        };
        this.showFilters = this.activeFeatureService.isFeatureActive('table_filters');
        this.isFiltersOpen = false;

        this.exports = [
            {
                name: this.translateService.getString('Checklist'),
                data: {
                    category: 'custom_ruleset',
                },
            },
        ];

        this.getPage();
    }

    override getPage = (): void => {
        const params: any = {};

        if (this.search) {
            params.search = this.search;
        }
        params.page = this.page;
        params.page_size = this.pageSize;
        params.sort_dir = this.currentSort.direction;
        params.sort_by = this.currentSort.by;
        params['regulations[]'] = this.filters['Data Regulations'].map((regulation: any) => {
            return regulation.value;
        });
        params['regions[]'] = this.filters.Country.map((region: any) => {
            return region.value;
        });
        params['group[]'] = this.filters['Issue type'].map((type: any) => {
            return type.value;
        });

        if (this.activeTab === 'passed') {
            params.compliant = true;
        } else {
            params.compliant = false;
            params.priority = this.activeTab;
        }

        this.progress = this.dataPrivacyRulesetRepo.getAll(params).then((infoTypes: any) => {
            this.infoTypes = infoTypes;
        }, () => {});
    };

    openHelpCenter (infoType: any): void {
        const params = {
            size: 'lg',
            body: PrivacyDialogsHelpCenterComponent,
            data: { infoType: infoType },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    goToPages (infoType: any): void {
        const params = {
            size: 'lg',
            body: PrivacyViolationPagesComponent,
            data: { infoType: infoType, totalPagesCount: this.infoTypes.total },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    onFiltersChanges (changes: any): void {
        this.filters = changes;
        this.getPage();
    }

    formatText (text: string): string {
        return this.dataPrivacyService.formatText(text);
    }

    getPagesWithActiveViolationCount (infoType: any): number {
        return this.dataPrivacyService.getPagesWithActiveViolationCount(infoType);
    }

    getTotalPageCount (infoType: any): number {
        return this.dataPrivacyService.getTotalPageCount(infoType);
    }

    trackByIndex (index: number): number {
        return index;
    }
}
